export default __webpack_public_path__ + "static/media/dial_doing_great.cd3c3006.svg";